export const SEARCH_WORKER_ID = "search-worker";
export const NATIVE_ROUTES_WORKER_ID = "native-routes-worker";
